export default __webpack_public_path__ + "static/media/Shirt4.089ff6b4.jpeg";